import axios from './common/axios';

/*
Saved for later
*/
export default {
  /**
   * List of Saved for Later / あとで買うリスト
   */
  getSavedForLater() {
    return new Promise(function(resolve, reject) {
      axios
        .get('/saved_for_later')
        .then((res) => {
          if (res.data.status !== 'ok') {
            return reject(res.data.errors);
          }
          return resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },

  /**
   * Add to Save for Later / あとで買うに追加
   * @param params.product Product ID
   * @param params.sku ProductSku ID
   */
  addToSavedForLater(params) {
    return new Promise(function(resolve, reject) {
      axios
        .post('/saved_for_later/add', {
          product: params.product,
          sku: params.sku
        })
        .then((res) => {
          if (res.data.status !== 'ok') {
            return reject(res.data.errors);
          }
          return resolve(null, res.data);
        })
        .catch((err) => reject(err));
    });
  },

  /**
   * Delete from Save for Later / あとで買うから削除
   * @param payload.id Saved for later ID
   */
  deleteFromSavedForLater(params) {
    return new Promise(function(resolve, reject) {
      axios
        .post('/saved_for_later/delete', {
          id: params.id
        })
        .then((res) => {
          if (res.data.status !== 'ok') {
            return reject(res.data.errors);
          }
          return resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  }
};
